var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureshield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4ce500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m600.02 769.35c98.113 0 177.94-79.828 177.94-177.94 0-98.117-79.828-177.94-177.94-177.94-98.117 0-177.94 79.828-177.94 177.94-0.003907 98.113 79.824 177.94 177.94 177.94zm-112.28-171.15c5.8594-5.8594 15.352-5.8594 21.211 0l45.57 45.57 136.56-136.56c5.8594-5.8594 15.352-5.8594 21.211 0 5.8594 5.8594 5.8594 15.352 0 21.211l-147.16 147.16c-2.9297 2.9297-6.7695 4.3945-10.605 4.3945-3.8398 0-7.6758-1.4648-10.605-4.3945l-56.176-56.176c-5.8594-5.8594-5.8594-15.352 0-21.211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.52 247.48v439.95c0 273.3 386.4 401.55 402.9 406.8 1.5 0.44922 3 0.75 4.6523 0.75 1.5 0 3-0.30078 4.5-0.75 16.5-5.25 402.9-133.5 402.9-406.8l0.003906-439.95c0-7.9492-6.1484-14.398-13.949-15-117.75-8.5508-267.75-30.301-384.15-124.2-5.4023-4.3516-13.352-4.3516-18.75 0-116.25 93.898-266.4 115.65-384.15 124.2-7.8008 0.60156-13.953 7.0508-13.953 15zm407.49 135.98c114.66 0 207.94 93.281 207.94 207.94s-93.281 207.94-207.94 207.94-207.94-93.281-207.94-207.94c-0.003907-114.66 93.277-207.94 207.94-207.94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureshield);
export default __webpack_public_path__ + "static/media/secureshield.e6aa40644a2bf48b1dce98e955a493c6.svg";
export { ForwardRef as ReactComponent };